import axios from 'axios'
import { i18n } from '@/main.js' 

export default({
    state: {
        topics: [],
        topic: null,

        createTopicDialog: false,
        editTopicDialog: false,

        activeTopic: undefined, // Currently viewing topic
        removing: false,

        // Values for editing a topic
        newName: '',
        newPosition: null,
    },

    getters: {
        getTopics(state){ return state.topics },
        getTopic(state){ return state.topic },

        getCreateTopicDialog(state){ return state.createTopicDialog },
        getEditTopicDialog(state){ return state.editTopicDialog },

        getActiveTopic(state){ return state.activeTopic },
        isRemovingTopic(state){ return state.removing },

        getTopicName(state){ return state.newName },
        getTopicPosition(state){ return state.newPosition },
    },

    mutations: {
        setTopics(state, value){ state.topics = value },
        setTopic(state, value){ state.topic = value},
        newTopic(state){
            state.topic = {
                name: null,
                position: state.topics.length+1,
                subjectId: localStorage.getItem('subjectId')
            }
        },

        setCreateTopicDialog(state, value){ state.createTopicDialog = value },
        setEditTopicDialog(state, value){ state.editTopicDialog = value },

        setActiveTopic(state, value){ state.activeTopic = value},
        setRemovingTopic(state, value){ state.removing = value },

        setTopicName(state, value){ state.newName = value },
        setTopicPosition(state, value){ state.newPosition = value },

        // Set editing topic values to current topic values. Used when editing a topic
        resetTopicValues(state) {
            state.newName = state.topic.name
            state.newPosition = state.topic.position
        }
    },

    actions: {
        getTopics({ commit }, filter){
            commit('setLoading')
            commit('setTopics', [])
            return new Promise((resolve) => {
                axios.get('/topics/' + localStorage.getItem('subjectId'), {
                    params: { filter }
                }).then((response) =>{
                    commit('setTopics', response.data)
                    resolve(response.data)
                })
                .catch(() => {})
                .then(() => {
                    commit('unsetLoading')
                })
            })
        },

        updateTopic({ state, commit, dispatch }){
            commit('setLoading')
            
            var newTopic = {...state.topic}

            newTopic.name = state.newName
            newTopic.position = state.newPosition

            return new Promise(() => {
                axios.put('/topics', newTopic)
                .then(() => {
                    commit('setEditTopicDialog', false)
                    commit('setSnackBar', {value: true, text: i18n.t('topicUpdated'), color: 'green'})
                    commit('setActiveTopic', undefined)
                    dispatch('getTopics')
                })
                .catch(() => {})
                .then(() => {
                    commit('unsetLoading')
                })
            })
        },

        createTopic({ state, commit, dispatch }){
            commit('setLoading')
            return new Promise(() => {
                axios.post('/topics', state.topic)
                .then(() => {
                    commit('setCreateTopicDialog', false)
                    commit('setSnackBar', {value: true, text: i18n.t('topicCreated'), color: 'green'})
                    dispatch('getTopics')
                })
                .catch(() => {})
                .then(() => {
                    commit('unsetLoading')
                })
            })
        },

        removeTopic({ state, commit, dispatch }){
            commit('setLoading')
            return new Promise(() => {
                axios.delete('/topics/' + state.topic.id)
                .then(() => {
                    commit('setEditTopicDialog', false)
                    commit('setSnackBar', {value: true, text: i18n.t('topicRemoved'), color: 'green'})
                    commit('setActiveTopic', undefined)
                    dispatch('getTopics')
                })
                .catch(() => {})
                .then(() => {
                    commit('unsetLoading')
                })
            })
        },
    },
});
